/* CQ Widget Kit — production behavior asset
   Scope-aware and instance-safe. No dependencies. */
(function () {
  'use strict';

  var initAttr = 'data-cqw-init';

  function mark(root) {
    if (!root || root.hasAttribute(initAttr)) return false;
    root.setAttribute(initAttr, '1');
    return true;
  }

  function parseJSON(el, fallback) {
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent || '');
    } catch (err) {
      return fallback;
    }
  }

  function setText(root, selector, value) {
    var el = root.querySelector(selector);
    if (el) el.textContent = value == null ? '' : String(value);
  }

  function initReveal() {
    var els = document.querySelectorAll('.cq-w-reveal:not(.is-in)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  function initBarCharts() {
    document.querySelectorAll('.cq-w-bar__row[data-cqw-bar-target]').forEach(function (row) {
      var value = parseFloat(row.getAttribute('data-cqw-bar-target'));
      if (!isFinite(value)) value = 0;
      value = Math.max(0, Math.min(100, value));
      row.style.setProperty('--cqw-bar-target', value + '%');
    });
  }

  function initStatCounters() {
    document.querySelectorAll('[data-cqw-stat]').forEach(function (root) {
      if (!mark(root)) return;

      function animateCount(el, target, duration) {
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min(1, (ts - start) / duration);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(target * eased).toLocaleString('en-US');
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }

      function fire() {
        root.querySelectorAll('[data-cqw-stat-num]').forEach(function (el) {
          var target = parseInt(el.getAttribute('data-target'), 10) || 0;
          animateCount(el, target, 4200);
        });
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            fire();
            io.disconnect();
          });
        }, { threshold: 0.35 });
        io.observe(root);
      } else {
        fire();
      }
    });
  }

  function initSteppers() {
    document.querySelectorAll('[data-cqw-stepper]').forEach(function (root) {
      if (!mark(root)) return;

      var data = parseJSON(root.querySelector('script[type="application/json"]'), []);
      var detail = root.querySelector('[data-cqw-step-detail], .cq-w-step__detail');
      var buttons = root.querySelectorAll('[data-cqw-step]');

      function show(idx) {
        var step = data[idx - 1];
        if (!step || !detail) return;
        detail.classList.add('is-fading');
        window.setTimeout(function () {
          detail.textContent = '';
          var title = document.createElement('h4');
          title.textContent = 'Step ' + idx + ' · ' + (step.title || '');
          var body = document.createElement('p');
          body.textContent = step.body || '';
          detail.appendChild(title);
          detail.appendChild(body);
          detail.classList.remove('is-fading');
        }, 180);
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          show(parseInt(btn.getAttribute('data-cqw-step'), 10));
        });
      });

      var active = root.querySelector('[data-cqw-step].is-active') || buttons[0];
      if (active) show(parseInt(active.getAttribute('data-cqw-step'), 10) || 1);
    });
  }

  function initTabs() {
    document.querySelectorAll('[data-cqw-tabs]').forEach(function (root) {
      if (!mark(root)) return;

      var buttons = root.querySelectorAll('[data-cqw-tab]');
      var panes = root.querySelectorAll('[data-cqw-pane]');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-cqw-tab');
          buttons.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          panes.forEach(function (pane) { pane.classList.remove('is-active'); });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          var active = root.querySelector('[data-cqw-pane="' + key + '"]');
          if (active) active.classList.add('is-active');
        });
      });
    });
  }

  function initAccordionLists() {
    document.querySelectorAll('[data-cqw-list]').forEach(function (root) {
      if (!mark(root)) return;

      root.querySelectorAll('[data-cqw-list-item]').forEach(function (item) {
        var trigger = item.querySelector('[data-cqw-list-trigger], .cq-w-list__head');
        if (!trigger) return;
        trigger.addEventListener('click', function () {
          var open = item.classList.toggle('is-open');
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });

  }

  function initCalculators() {
    document.querySelectorAll('[data-cqw-calculator]').forEach(function (root) {
      if (!mark(root)) return;

      var inputs = root.querySelectorAll('[data-cqw-calc]');
      var out = root.querySelector('[data-cqw-calc-out]');
      var note = root.querySelector('[data-cqw-calc-note]');
      var toggle = root.querySelector('[data-cqw-calc-toggle]');
      var defaultNote = root.getAttribute('data-default-note') || 'Estimated annualized cost based on the values selected.';
      var toggleNote = root.getAttribute('data-toggle-note') || 'Filtered-water estimate based on the values selected.';
      var bottleCost = parseFloat(root.getAttribute('data-bottle-cost')) || 0.85;
      var filteredYearly = parseFloat(root.getAttribute('data-filtered-yearly-cost')) || 50;
      var lastResult = 0;
      var tweenRAF = null;

      function setSliderFill(input) {
        var min = parseFloat(input.min) || 0;
        var max = parseFloat(input.max) || 100;
        var value = parseFloat(input.value) || min;
        var pct = max > min ? ((value - min) / (max - min)) * 100 : 0;
        input.style.setProperty('--cqw-slider-pct', pct + '%');
      }

      function tween(from, to, duration, callback) {
        if (tweenRAF) cancelAnimationFrame(tweenRAF);
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min(1, (ts - start) / duration);
          var eased = 1 - Math.pow(1 - progress, 3);
          callback(from + (to - from) * eased);
          if (progress < 1) tweenRAF = requestAnimationFrame(step);
          else tweenRAF = null;
        }
        tweenRAF = requestAnimationFrame(step);
      }

      function compute() {
        var values = {};
        inputs.forEach(function (input) {
          var key = input.getAttribute('data-cqw-calc');
          var value = parseInt(input.value, 10) || 0;
          values[key] = value;
          setText(root, '[data-display="' + key + '"]', value);
          setSliderFill(input);
        });

        var people = values.people || 1;
        var bottles = values.bottles || 1;
        var years = values.years || 1;
        var result = people * bottles * 365 * years * bottleCost;

        if (toggle && toggle.checked) {
          result = years * filteredYearly;
          if (note) note.textContent = toggleNote;
        } else if (note) {
          note.textContent = defaultNote;
        }
        root.classList.toggle('is-filtered', !!(toggle && toggle.checked));

        if (out) {
          tween(lastResult, result, 300, function (value) {
            out.textContent = '$' + Math.round(value).toLocaleString('en-US');
          });
        }
        lastResult = result;
      }

      inputs.forEach(function (input) {
        input.addEventListener('input', compute);
        setSliderFill(input);
      });
      if (toggle) toggle.addEventListener('change', compute);
      compute();
    });
  }

  function initQuizzes() {
    document.querySelectorAll('[data-cqw-quiz]').forEach(function (root) {
      if (!mark(root)) return;

      var results = parseJSON(root.querySelector('[data-cqw-quiz-results]'), {});
      var questionSteps = Array.prototype.slice.call(root.querySelectorAll('[data-cqw-quiz-step]'))
        .filter(function (step) { return step.getAttribute('data-cqw-quiz-step') !== 'result'; });
      var total = questionSteps.length;
      var fill = root.querySelector('[data-cqw-quiz-fill]');
      var label = root.querySelector('[data-cqw-quiz-label]');
      var backBtn = root.querySelector('[data-cqw-quiz-back]');
      var scores = [];
      var current = 1;

      function goTo(idx) {
        root.querySelectorAll('[data-cqw-quiz-step]').forEach(function (step) {
          step.classList.remove('is-active');
        });
        current = idx;

        if (idx === 'result') {
          var resultStep = root.querySelector('[data-cqw-quiz-step="result"]');
          if (resultStep) resultStep.classList.add('is-active');
          if (fill) fill.style.width = '100%';
          if (label) label.textContent = 'Your result';
          if (backBtn) backBtn.hidden = true;
          return;
        }

        var active = root.querySelector('[data-cqw-quiz-step="' + idx + '"]');
        if (active) active.classList.add('is-active');
        if (fill) fill.style.width = ((idx - 1) / Math.max(total, 1) * 100) + '%';
        if (label) label.textContent = 'Question ' + idx + ' / ' + total;
        if (backBtn) backBtn.hidden = idx <= 1;
      }

      function chooseResult() {
        var sum = scores.reduce(function (a, b) { return a + b; }, 0);
        var avg = scores.length ? sum / scores.length : 1;
        var key = avg < 1.5 ? '1' : (avg < 2.5 ? '2' : '3');
        return results[key] || results.default || {};
      }

      function showResult() {
        var result = chooseResult();
        setText(root, '[data-cqw-quiz-badge]', result.badge || '');
        setText(root, '[data-cqw-quiz-title]', result.title || 'Your result');
        setText(root, '[data-cqw-quiz-body]', result.body || '');
        setText(root, '[data-cqw-quiz-pname]', result.pname || '');
        setText(root, '[data-cqw-quiz-pprice]', result.pprice || '');

        var href = result.href || '#';
        var product = root.querySelector('[data-cqw-quiz-product]');
        var cta = root.querySelector('[data-cqw-quiz-cta]');
        if (product) product.setAttribute('href', href);
        if (cta) cta.setAttribute('href', href);

        var image = root.querySelector('[data-cqw-quiz-pimg]');
        if (image && result.pimg) {
          image.textContent = '';
          if (/^https?:\/\//.test(result.pimg)) {
            var img = document.createElement('img');
            img.src = result.pimg;
            img.alt = result.pname || result.title || '';
            img.loading = 'lazy';
            image.appendChild(img);
          } else {
            image.textContent = result.pimg;
          }
        }

        goTo('result');
      }

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (typeof current === 'number' && current > 1) goTo(current - 1);
        });
      }

      root.querySelectorAll('[data-cqw-quiz-opt]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          var step = opt.closest('[data-cqw-quiz-step]');
          if (!step) return;
          step.querySelectorAll('[data-cqw-quiz-opt]').forEach(function (o) {
            o.classList.remove('is-selected');
          });
          opt.classList.add('is-selected');
          var idx = parseInt(step.getAttribute('data-cqw-quiz-step'), 10);
          scores[idx - 1] = parseInt(opt.getAttribute('data-score'), 10) || 1;
          window.setTimeout(function () {
            if (idx < total) goTo(idx + 1);
            else showResult();
          }, 180);
        });
      });

      var reset = root.querySelector('[data-cqw-quiz-reset]');
      if (reset) {
        reset.addEventListener('click', function () {
          scores = [];
          root.querySelectorAll('[data-cqw-quiz-opt].is-selected').forEach(function (opt) {
            opt.classList.remove('is-selected');
          });
          goTo(1);
        });
      }
    });
  }

  function initChecklists() {
    document.querySelectorAll('[data-cqw-checklist]').forEach(function (root) {
      if (!mark(root)) return;

      var total = parseInt(root.getAttribute('data-total'), 10) ||
        root.querySelectorAll('[data-cqw-check-item]').length;
      var threshold = parseInt(root.getAttribute('data-cta-threshold'), 10) || total;
      var ring = root.querySelector('[data-cqw-check-ring]');
      var count = root.querySelector('[data-cqw-check-count]');
      var cta = root.querySelector('[data-cqw-check-cta]');
      var circumference = 2 * Math.PI * 60;

      function update() {
        var done = root.querySelectorAll('[data-cqw-check-item].is-done').length;
        if (count) count.textContent = done;
        if (ring) ring.style.strokeDashoffset = (circumference * (1 - done / Math.max(total, 1))).toFixed(2);
        if (cta) cta.classList.toggle('is-shown', done >= threshold);
        root.classList.toggle('is-complete', total > 0 && done === total);
      }

      root.querySelectorAll('[data-cqw-check-item]').forEach(function (item) {
        item.setAttribute('tabindex', item.getAttribute('tabindex') || '0');
        item.setAttribute('role', item.getAttribute('role') || 'checkbox');
        item.setAttribute('aria-checked', item.classList.contains('is-done') ? 'true' : 'false');
        function toggle() {
          var done = item.classList.toggle('is-done');
          item.setAttribute('aria-checked', done ? 'true' : 'false');
          update();
        }
        item.addEventListener('click', toggle);
        item.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          toggle();
        });
      });

      update();
    });
  }

  function initStepVisuals() {
    document.querySelectorAll('[data-cqw-stepvis]').forEach(function (root) {
      if (!mark(root)) return;

      var data = parseJSON(root.querySelector('[data-cqw-stepvis-data], script[type="application/json"]'), []);
      var panel = root.querySelector('[data-cqw-stepvis-panel], .cq-w-stepvis__panel');
      var title = root.querySelector('[data-cqw-stepvis-title]');
      var body = root.querySelector('[data-cqw-stepvis-body]');
      var aFill = root.querySelector('[data-cqw-stepvis-a-fill]');
      var aVal = root.querySelector('[data-cqw-stepvis-a-val]');
      var aNote = root.querySelector('[data-cqw-stepvis-a-note]');
      var bFill = root.querySelector('[data-cqw-stepvis-b-fill]');
      var bVal = root.querySelector('[data-cqw-stepvis-b-val]');
      var bNote = root.querySelector('[data-cqw-stepvis-b-note]');
      var buttons = root.querySelectorAll('[data-cqw-stepvis-step]');

      function show(idx) {
        var step = data[idx - 1];
        if (!step) return;
        if (panel) panel.classList.add('is-fading');
        window.setTimeout(function () {
          if (title) title.textContent = step.title || '';
          if (body) body.textContent = step.body || '';
          if (aVal) aVal.textContent = (step.a || 0) + '%';
          if (bVal) bVal.textContent = (step.b || 0) + '%';
          if (aNote) aNote.textContent = step.a_note || '';
          if (bNote) bNote.textContent = step.b_note || '';
          if (panel) panel.classList.remove('is-fading');
          requestAnimationFrame(function () {
            if (aFill) aFill.style.width = (step.a || 0) + '%';
            if (bFill) bFill.style.width = (step.b || 0) + '%';
          });
        }, 180);
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          show(parseInt(btn.getAttribute('data-cqw-stepvis-step'), 10));
        });
      });

      var active = root.querySelector('[data-cqw-stepvis-step].is-active') || buttons[0];
      if (active) show(parseInt(active.getAttribute('data-cqw-stepvis-step'), 10) || 1);
    });
  }

  function initAll() {
    initReveal();
    initBarCharts();
    initStatCounters();
    initSteppers();
    initTabs();
    initAccordionLists();
    initCalculators();
    initQuizzes();
    initChecklists();
    initStepVisuals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
